import { useEffect } from 'react';
import { Hero } from '../components/Hero';
import { ServiceGrid } from '../components/ServiceGrid';
import { ThreeStepFix } from '../components/ThreeStepFix';
import { ServiceAreas } from '../components/ServiceAreas';
import { AboutSection } from '../components/AboutSection';
import { BrandsSlider } from '../components/BrandsSlider';
import { Testimonials } from '../components/Testimonials';

// Updated JSON-LD Schema with all 8 service areas
const homeSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Infinity Appliances Repair",
  "image": "https://customer-assets.emergentagent.com/job_infinity-gta-repair/artifacts/382cgbmn_WhatsApp%20Image%202026-03-04%20at%2012.45.59.jpeg",
  "@id": "https://infinityappliances.com",
  "url": "https://infinityappliances.com",
  "telephone": "+1-647-919-6893",
  "priceRange": "$$",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Toronto",
    "addressRegion": "ON",
    "addressCountry": "CA"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 43.6532,
    "longitude": -79.3832
  },
  "openingHoursSpecification": {
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
    "opens": "00:00",
    "closes": "23:59"
  },
  "sameAs": [],
  "areaServed": [
    { "@type": "City", "name": "Toronto", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "East York", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "North York", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "Vaughan", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "Richmond Hill", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "King City", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "Woodbridge", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } },
    { "@type": "City", "name": "Markham", "containedInPlace": { "@type": "AdministrativeArea", "name": "Ontario" } }
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Appliance Repair Services",
    "itemListElement": [
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Refrigerator Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Washer & Dryer Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Dishwasher Repair" } },
      { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Stove & Oven Repair" } }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "reviewCount": "150"
  }
};

export const HomePage = () => {
  useEffect(() => {
    // Set page title and meta description
    document.title = 'Same-Day Appliance Repair Toronto & GTA | Infinity Appliances';
    
    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'Infinity Appliances Repair provides expert, same-day service in Toronto, Vaughan, Richmond Hill, Markham & all GTA. Certified technicians for Samsung, LG, Whirlpool, and all major brands. Book your 2-hour window now.';

    // JSON-LD Schema
    let schemaScript = document.querySelector('#home-schema');
    if (!schemaScript) {
      schemaScript = document.createElement('script');
      schemaScript.id = 'home-schema';
      schemaScript.type = 'application/ld+json';
      document.head.appendChild(schemaScript);
    }
    schemaScript.textContent = JSON.stringify(homeSchema);

    return () => {
      // Cleanup
    };
  }, []);

  return (
    <main data-testid="home-page">
      <Hero />
      <ServiceGrid />
      <ThreeStepFix />
      <AboutSection />
      <ServiceAreas />
      <BrandsSlider />
      <Testimonials />
    </main>
  );
};

export default HomePage;
